var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInboxDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M6.334 3h8.004c.113 0 .226.008.337.024l.08-.017.1-.007c.205 0 .39.093.512.24.13.063.254.139.371.227l.147.12 3.48 3.08c.2.177.366.385.493.614a.668.668 0 0 1 .263.754c.02.125.031.252.031.38a.667.667 0 0 1-1.328.087h-3.136A1.5 1.5 0 0 1 14.188 7l-.001-2.668H6.334a1 1 0 0 0-.994.884l-.006.117v13.303a1 1 0 0 0 .88.993l.117.007 11.485.03c.515 0 .938-.387.996-.884l.006-.117v-2.258a.667.667 0 0 1 1.327-.098l.007.098v2.258c0 1.235-.96 2.246-2.174 2.329l-.16.005h-.006l-11.484-.03a2.334 2.334 0 0 1-2.323-2.174L4 18.636V5.335c0-1.235.96-2.246 2.174-2.329L6.334 3h8.004zM21.36 9.578c.405.349.476.941.183 1.373l-.074.097-5.398 6.265c-.378.44-1.035.48-1.464.114l-.089-.085-2.51-2.701a1.042 1.042 0 0 1 1.431-1.51l.095.091 1.718 1.849 4.639-5.384a1.042 1.042 0 0 1 1.469-.109zm-3.442-2.411-2.397-2.122v1.956c0 .074.048.136.114.158l.053.009 2.23-.001z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24-10h268v44H-24z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInboxDone);
export default __webpack_public_path__ + "static/media/ic-inbox-done.390bd9c4820744f1cdc098a645d59483.svg";
export { ForwardRef as ReactComponent };